import React, { Component } from "react";
import PropTypes from "prop-types";

import BarSeries from "./BarSeries";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class MACDSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForMACD = this.yAccessorForMACD.bind(this);
    this.yAccessorForSignal = this.yAccessorForSignal.bind(this);
    this.yAccessorForDivergence = this.yAccessorForDivergence.bind(this);
    this.yAccessorForDivergenceBase =
      this.yAccessorForDivergenceBase.bind(this);
  }
  yAccessorForMACD(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).macd;
  }
  yAccessorForSignal(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).signal;
  }
  yAccessorForDivergence(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).divergence;
  }
  yAccessorForDivergenceBase(xScale, yScale /* , d */) {
    return yScale(0);
  }
  render() {
    const { className, widthRatio, onDoubleClick, onContextMenu, yAccessor } =
      this.props;

    const { strokeMACD, strokeSignal, strokeZeroLine, barDivergence } =
      this.props;

    const { clip } = this.props;

    // Ensure barDivergence has default values for backward compatibility
    const safeBarDivergence = barDivergence || {};
    const barWidth = safeBarDivergence.width ?? 1;
    const barOpacity = safeBarDivergence.opacity ?? 0.6;

    // Support both old format (fillColor) and new format (increasingColor/decreasingColor)
    // Default colors from ChartIQ CSS: .stx_histogram_up (#8cc176) and .stx_histogram_down (#b82c0c)
    const increasingColor = safeBarDivergence.increasingColor ?? "#8cc176";
    const decreasingColor =
      safeBarDivergence.decreasingColor ??
      safeBarDivergence.fillColor ??
      "#b82c0c";

    // Create fill function that determines color based on divergenceDirection
    const fillFunction = (d) => {
      const macdData = yAccessor(d);
      if (!macdData || !macdData.divergenceDirection) {
        return decreasingColor;
      }
      return macdData.divergenceDirection === "up"
        ? increasingColor
        : decreasingColor;
    };

    return (
      <g className={className}>
        <BarSeries
          baseAt={this.yAccessorForDivergenceBase}
          className="macd-divergence"
          width={barWidth}
          widthRatio={widthRatio}
          stroke={true}
          fill={fillFunction}
          opacity={barOpacity}
          clip={clip}
          yAccessor={this.yAccessorForDivergence}
        />
        <LineSeries
          yAccessor={this.yAccessorForMACD}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeMACD}
        />
        <LineSeries
          yAccessor={this.yAccessorForSignal}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeSignal}
        />
        <StraightLine
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeZeroLine}
          yValue={0}
        />
      </g>
    );
  }
}

MACDSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  divergenceStroke: PropTypes.bool,
  clip: PropTypes.bool.isRequired,
  strokeMACD: PropTypes.object.isRequired,
  strokeSignal: PropTypes.object.isRequired,
  strokeZeroLine: PropTypes.object.isRequired,
  barDivergence: PropTypes.object.isRequired,
  widthRatio: PropTypes.number,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

MACDSeries.defaultProps = {
  className: "react-stockcharts-macd-series",

  divergenceStroke: false,
  clip: true,
  widthRatio: 0.5,
};

export default MACDSeries;
